import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "doctor-avatar-editor",
      attrs: { "data-qa": "doctor-avatar-editor" },
    },
    [
      _c(
        "div",
        {
          staticClass: "doctor-avatar-editor__activator",
          on: { click: _setup.onPickClick },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInputRef",
        staticClass: "d-none",
        attrs: { type: "file", accept: "image/jpeg,image/png,image/webp" },
        on: { change: _setup.onFileChange },
      }),
      _vm._v(" "),
      _c(_setup.DoctorAvatarEditorModal, {
        attrs: {
          value: _setup.isPreviewOpen,
          title: _setup.t("Фотография профиля", _setup.l10nOptions),
          "is-loading": _setup.isLoading,
          "image-src": _setup.previewSrc,
          "is-staff": _setup.isStaff,
          "is-upscaling-enabled": _setup.isUpscalingEnabled,
          "is-init-upscale-photo": _setup.isUpscaleImage,
        },
        on: {
          cancel: _setup.closePreview,
          submit: _setup.saveAvatar,
          "rotate-clockwise": function ($event) {
            return _setup.rotateBy(_setup.ROTATION_ANGLE_PER_STEP)
          },
          "rotate-counter-clockwise": function ($event) {
            return _setup.rotateBy(-_setup.ROTATION_ANGLE_PER_STEP)
          },
          "switch-crop-photo": _setup.onSwitchCropPhoto,
          "switch-upscale-photo": _setup.onSwitchUpscalePhoto,
        },
      }),
      _vm._v(" "),
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "doctor-avatar-editor-alert",
            size: "sm",
            title: _setup.alertTitle,
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "text", text: "" },
                      on: { click: _setup.closeAlert },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("Закрыть", _setup.l10nOptions)) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: { click: _setup.retryPick },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("Выбрать фото", _setup.l10nOptions)) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.isAlertOpen,
            callback: function ($$v) {
              _setup.isAlertOpen = $$v
            },
            expression: "isAlertOpen",
          },
        },
        [
          _setup.alertText
            ? _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
                _vm._v("\n      " + _vm._s(_setup.alertText) + "\n    "),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }